import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';
declare let $: any

@Component({
  selector: 'app-proposal-details',
  templateUrl: './proposal-details.component.html',
  styleUrls: ['./proposal-details.component.scss']
})
export class ProposalDetailsComponent implements OnInit ,OnChanges{
@Input() insuredDetail;
@Input() myProposalDetails;
@Input() casedata;
@Input() showMessages:boolean=false
 reminingmessages:boolean=false;
 @Input() borderbottom=true
 @Input() alinemet:boolean=false;
 @Output() clickhelpIcon = new EventEmitter();
 isVisible=false
 showdetails=false
 helplabel
 validationmessage=false;
 validationreminingMesages=false;
 RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
 helpicon=this.RESOURCE_SERVER_URL+'/assets/images/Case_Review_Icons/BMI.svg'
 msgPath=this.RESOURCE_SERVER_URL + '/assets/images/Message.svg'
  constructor( private commonService: CommonService,private dialog: MatDialog,) {
    this.commonService.showHelpIcon.subscribe(data => {
      this.isVisible = data;
    })
    $(document).ready(function () {
      $(".help-icons").click(function () {
        $(this).position();
      })
    });
    this.commonService.languagechnage.subscribe(data=>{
      if (data){
        this.helplabel=this.commonService.language;
      }
    })
   }
  ngOnInit(): void {
    if(this.insuredDetail.summary.uwJetRules.length == 0){
      this.insuredDetail.summary.uwJetRules=[]
      this.insuredDetail.summary.uwJetRules.push("label.casereview.warnmsg")
      this.insuredDetail.summary.uwJetRules.push("Hazardous Life Style")
    }
    this.helplabel=this.commonService.language
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.validationmessage=false;
    this.validationreminingMesages=false;
    this.reminingmessages=false;
  }
  showReminingmessages(){
    this.reminingmessages=!this.reminingmessages
  }
  dataisemity(data){
    if(data){
      return data;
    }else{
      return '-'
    }
  }

  //filtering to show keyvalue  full defenation(name)
  findkeyLabel(item:any,type:string){
    let label=''
    if( this.commonService.lookupList != undefined && item){
    this.commonService.lookupList[type].map(data=>{
      if(data.value == item || item.toUpperCase() == data.label.toUpperCase()){
        label= data.label;
      }
    })
    }
    return label
  }
  showhelpdetails(label,helplabel){
    this.clickhelpIcon.emit({id:helplabel,headerlabel:label,discriptio:helplabel,component:'details'})
  }
  showValidationMessage(){
    this.validationmessage=!this.validationmessage
  }
  showvalidationReminingmessages(){
    this.validationreminingMesages=!this.validationreminingMesages
  }
  dateFormeting(value){
    return this.commonService.formetdateGetingfromAPI(value)
  }
}
